'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../node_modules/prop-types/index.js');

var index$1 = require('../../../node_modules/classnames/index.js');

var subHam_inline = require('../../../assets/svg/sub-ham.inline.svg.js');

require('../../../templates/Article/Article.js');

require('../../../templates/ArticleInfoBlock/ArticleInfoBlock.js');

require('../../../templates/ArticleList/ArticleList.js');

require('../../../templates/ArticleList/ArticleListItemImage/ArticleListItemImage.js');

var BreadCrumbs = require('../../../templates/BreadCrumbs/BreadCrumbs.js');

require('../../../templates/ContentBody/ContentBody.js');

require('../../../templates/ContentIntroduction/ContentIntroduction.js');

require('../../../templates/ContentTitle/ContentTitle.js');

require('../../../templates/NewsletterSubscription/NewsletterSubscription.js');

require('../../../templates/PageHeader/PageHeader.js');

require('../../../templates/Pagination/Pagination.js');

require('../../../templates/Section/Section.js');

require('../../../templates/Section/SectionHeader/SectionHeader.js');

require('../../../templates/SideBar/SideBar.js');

require('../../../templates/SideBar/ContactsBlock/ContactsBlock.js');

require('../../../templates/SideBar/ListBlock/ListBlock.js');

require('../../../templates/SideBar/ListenBlock/ListenBlock.js');

require('../../../templates/SideBar/MediaContactBlock/MediaContactBlock.js');

require('../../../templates/SideBar/SearchBlock/SearchBlock.js');

require('../../../templates/SideBar/SocialBlock/SocialBlock.js');

require('../../../templates/SideBar/TopicBlock/TopicBlock.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var SideNavMobile = function SideNavMobile(_ref) {
  var className = _ref.className,
      children = _ref.children,
      location = _ref.location,
      setShowMenu = _ref.setShowMenu,
      showMenu = _ref.showMenu,
      homeName = _ref.homeName;
  var classes = index$1['default']('lanl-side-nav-mobile', className);

  var renderMenu = function renderMenu() {
    var overlayClasses = index$1['default']('mobile-overlay', showMenu && 'show');
    return showMenu && /*#__PURE__*/React__default['default'].createElement("div", {
      className: overlayClasses
    }, children);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-side-nav-mobile"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    onClick: function onClick() {
      return setShowMenu(!showMenu);
    },
    type: "button",
    "aria-label": "open",
    className: "menu-btn"
  }, /*#__PURE__*/React__default['default'].createElement(subHam_inline['default'], null)), /*#__PURE__*/React__default['default'].createElement(BreadCrumbs.BreadCrumbs, {
    homeName: homeName,
    location: location
  }), renderMenu());
};

SideNavMobile.defaultProps = {
  location: {},
  showMenu: false,
  homeName: ''
};
SideNavMobile.propTypes = {
  children: index['default'].node.isRequired,
  className: index['default'].string,
  homeName: index['default'].string,
  location: index['default'].object,
  setShowMenu: index['default'].func,
  showMenu: index['default'].bool
};
exports.SideNavMobile = SideNavMobile;
exports['default'] = SideNavMobile;